import { render, staticRenderFns } from "./AbbreviationList.vue?vue&type=template&id=7aa2d84b"
import script from "./AbbreviationList.vue?vue&type=script&lang=js"
export * from "./AbbreviationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports